// extracted by mini-css-extract-plugin
module.exports = {"page":"PageWrapper_page__2t9yD","pageNumber":"PageWrapper_pageNumber__3LT_q","text":"PageWrapper_text__3dQvF","innerPage":"PageWrapper_innerPage__YU5r6"};